import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Select from 'antd/es/select';
import { useState } from 'react';
import { NotificationFrequency, } from '../../features/entities';
import { useTranslations } from '../../features/providers/translations-provider';
import theme from '../../theme';
import Button from '../common/button';
import Div from '../common/div';
import Typography from '../common/typography';
const FrequencyJourneyModal = ({ notification, setFrequencyModal, handleFrequencyChange, }) => {
    const { t } = useTranslations();
    const { grant_id, industry_id, tag_id, subject_title, frequency } = notification;
    const [newFrequency, setNewFrequency] = useState(frequency);
    const frequencyOptions = [
        {
            value: NotificationFrequency.instant,
            label: t(`notification|frequency_instant`),
        },
        {
            value: NotificationFrequency.daily,
            label: t(`notification|frequency_daily`),
        },
        {
            value: NotificationFrequency.weekly,
            label: t(`notification|frequency_weekly`),
        },
    ];
    return (_jsxs(Div, { flex: "column", align: "center", justify: "center", gap: 24, children: [_jsxs(Div, { flex: "column", align: "center", justify: "center", gap: 8, children: [_jsx(Typography, { elementTheme: "subtitle1", children: t('notification|changeFrequencyTitle') }), _jsx(Typography, { elementTheme: "body1", children: subject_title })] }), _jsx(Div, { flex: "column", align: "center", justify: "center", gap: 8, children: _jsx(Select, { placeholder: t('notification|frequency'), style: { width: '100%' }, onChange: (value) => setNewFrequency(value), options: frequencyOptions, defaultValue: frequency }) }), _jsxs(Div, { flex: "row", gap: 8, justify: "center", children: [_jsx(Button, { onClick: () => setFrequencyModal(false), size: "small", style: {
                            backgroundColor: theme.colors.grey_4,
                            borderColor: theme.colors.grey_4,
                        }, children: t('button|cancel') }), _jsx(Button, { onClick: () => {
                            handleFrequencyChange(grant_id, industry_id, tag_id, newFrequency);
                            setFrequencyModal(false);
                        }, size: "small", style: {
                            backgroundColor: theme.colors.purple_2,
                            borderColor: theme.colors.purple_2,
                        }, children: t('button|confirm') })] })] }));
};
export default FrequencyJourneyModal;
